<div class="datepicker">
  <div
    [class.disabled]="isDisable"
    [class.full]="isFull"
    (click)="openDatePicker()"
    class="datepicker__select">
    <span
      *ngIf="date"
      class="datepicker__select-date">
      {{date | date : 'dd.MM.YYYY'}}
    </span>
    <span
      *ngIf="date"
      class="datepicker__select-time">
      {{date | date : 'HH:mm:ss'}}
    </span>
  </div>
  <div
    [class.active]="isOpenDatePicker"
    [class.top]="horizontalPosition === 'top'"
    [class.center]="horizontalPosition === 'center'"
    [class.semi-top]="horizontalPosition === 'semi-top'"
    [class.left]="verticalPosition === 'left'"
    [class.right]="verticalPosition === 'right'"
    class="datepicker__calendar">
    <div class="datepicker__calendar-mount">
      <button
        (click)="nextMount()"
        class="next-mount">
      </button>
      <span
        class="mount-year">
        {{'DATEPICKER.' + mount | translate}} {{year}}
      </span>
      <button
        (click)="prevMount()"
        class="prev-mount">
      </button>
    </div>
    <div class="datepicker__calendar-week">
      <div class="item">{{'DATEPICKER.MO' | translate}}</div>
      <div class="item">{{'DATEPICKER.TU' | translate}}</div>
      <div class="item">{{'DATEPICKER.WE' | translate}}</div>
      <div class="item">{{'DATEPICKER.TH' | translate}}</div>
      <div class="item">{{'DATEPICKER.FR' | translate}}</div>
      <div class="item">{{'DATEPICKER.SA' | translate}}</div>
      <div class="item">{{'DATEPICKER.SU' | translate}}</div>
    </div>
    <div class="datepicker__calendar-day">
      <div
        *ngFor="let day of daysArray"
        (click)="setDay(year, mount, day)"
        [class.invisible]="day === 0"
        [class.active]="selectedDate?.getFullYear() === year && selectedDate?.getMonth() === mount && selectedDate?.getDate() === day"
        class="item">
        {{day}}
      </div>
    </div>
    <div class="datepicker__calendar-time">
      <span class="time">{{'DATEPICKER.TIME' | translate}}</span>
      <input
        [(ngModel)]="selectedHours"
        (input)="setHours()"
        mask="00"
        type="text"
        inputmode="numeric"
        class="set-time">
      <span>:</span>
      <input
        [(ngModel)]="selectedMinute"
        (input)="setMinutes()"
        mask="00"
        type="text"
        inputmode="numeric"
        class="set-time">
      <span>:</span>
      <input
        [(ngModel)]="selectedSecond"
        (input)="setSecond()"
        mask="00"
        type="text"
        inputmode="numeric"
        class="set-time">
    </div>
    <div class="datepicker__calendar-selected">
      <span class="title">{{'DATEPICKER.SELECTED' | translate}}</span>
      <span
        *ngIf="selectedDate"
        class="setting-date">
        {{selectedDate | date : 'dd/MM/YYYY'}},
      </span>
      <span
        *ngIf="selectedDate"
        class="setting-time">
        {{selectedDate | date : 'HH:mm:ss'}}
      </span>
    </div>
    <div class="datepicker__calendar-btn-block">
      <button
        (click)="closeDatePicker()"
        class="btn btn-light">
        {{'DATEPICKER.CANCEL' | translate}}
      </button>
      <button
        [disabled]="!selectedDate"
        (click)="selectDateAndTime()"
        class="btn btn-accent">
        {{'DATEPICKER.SELECT' | translate}}
      </button>
    </div>
  </div>
</div>
